(function (Drupal, once, $, settings) {

  Drupal.behaviors.contactUs = {
    attach: function attach(context) {
      $("h4.sub-label > a", context).click(function (e) {
        e.preventDefault();
        $.find($(this).attr('href'), context)[0].scrollIntoView(
          {
            behavior: 'smooth',
            block: 'start'
          }
        );
      });
    }
  };
})(Drupal, once, jQuery, drupalSettings);
